import { render, staticRenderFns } from "./CollegePurchaseClass.vue?vue&type=template&id=7b91278a"
import script from "./CollegePurchaseClass.vue?vue&type=script&lang=js"
export * from "./CollegePurchaseClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports